"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcMTGDiyMinInvest = exports.calculateMartingaleMinInvest = exports.useMTGMultiMinInvest = exports.useMTGMultiAIInfo = exports.useMartingaleAIInfo = exports.getMaxSafetyOrdersByVolumeScale = exports.getVolumeScaleConfig = exports.MartingaleMaxSupportCoin = exports.MartingaleVolumeScaleDefault = exports.MartingaleTakeProfitTrailingPercentageMin = exports.MartingaleTakeProfitRatioMin = exports.MartingalePriceScalePercentageMax = exports.MartingalePriceScaleTrailingPercentageMin = exports.MartingalePriceScalePercentageMin_SmartTradeMode = exports.MartingalePriceScalePercentageMin = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const SimpleTrading_1 = require("../SimpleTrading");
const operators_1 = require("rxjs/operators");
exports.MartingalePriceScalePercentageMin = 0.001;
exports.MartingalePriceScalePercentageMin_SmartTradeMode = 0.002;
exports.MartingalePriceScaleTrailingPercentageMin = 0.001;
exports.MartingalePriceScalePercentageMax = 0.15;
exports.MartingaleTakeProfitRatioMin = 0.002;
exports.MartingaleTakeProfitTrailingPercentageMin = 0.001;
exports.MartingaleVolumeScaleDefault = "2.0";
exports.MartingaleMaxSupportCoin = 30;
const SafetyOrderByVolumeScaleArray = [
    {
        volumeScale: 1,
        minSafetyOrder: 1,
        maxSafeOrder: 50,
    },
    {
        volumeScale: 1.1,
        minSafetyOrder: 1,
        maxSafeOrder: 25,
    },
    {
        volumeScale: 1.2,
        minSafetyOrder: 1,
        maxSafeOrder: 16,
    },
    {
        volumeScale: 1.3,
        minSafetyOrder: 1,
        maxSafeOrder: 15,
    },
    {
        volumeScale: 1.4,
        minSafetyOrder: 1,
        maxSafeOrder: 15,
    },
    {
        volumeScale: 1.5,
        minSafetyOrder: 1,
        maxSafeOrder: 15,
    },
    {
        volumeScale: 1.6,
        minSafetyOrder: 1,
        maxSafeOrder: 15,
    },
    {
        volumeScale: 1.7,
        minSafetyOrder: 1,
        maxSafeOrder: 12,
    },
    {
        volumeScale: 1.8,
        minSafetyOrder: 1,
        maxSafeOrder: 12,
    },
    {
        volumeScale: 1.9,
        minSafetyOrder: 1,
        maxSafeOrder: 12,
    },
    {
        volumeScale: 2,
        minSafetyOrder: 1,
        maxSafeOrder: 12,
    },
];
function getVolumeScaleConfig() {
    return SafetyOrderByVolumeScaleArray;
}
exports.getVolumeScaleConfig = getVolumeScaleConfig;
function getMaxSafetyOrdersByVolumeScale(volumeScale) {
    const volNum = Number(volumeScale);
    const find = SafetyOrderByVolumeScaleArray.find((item) => item.volumeScale === volNum);
    return (find !== null && find !== void 0 ? find : {
        minSafetyOrder: 1,
        maxSafeOrder: 5,
    });
}
exports.getMaxSafetyOrdersByVolumeScale = getMaxSafetyOrdersByVolumeScale;
function useMartingaleAIInfo(tradeApi, base, quote) {
    const [items, setItems] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        setLoading(true);
        const retryOb = (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.requestMTGAIStrategyWithSymbol(base, quote), { maxRetryCount: 3 }).subscribe({
            next: (data) => {
                setItems(data);
                setError("");
                setLoading(false);
            },
            error: (error) => {
                setError(JSON.stringify(error) || `${error}`);
                setLoading(false);
            },
        });
        return () => retryOb && retryOb.unsubscribe();
    }, [base, quote]);
    return [items, loading, error];
}
exports.useMartingaleAIInfo = useMartingaleAIInfo;
/**
 * 获取mtg多币ai参数中位数信息
 * @param tradeApi
 * @param pairs
 */
function useMTGMultiAIInfo(tradeApi, pairs) {
    const [items, setItems] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        if (pairs.length === 0) {
            return;
        }
        setLoading(true);
        const retryOb = (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.requestMTGMultiAIStrategyWithSymbols(pairs), { maxRetryCount: 3 })
            .pipe((0, operators_1.map)((data) => {
            let strategiesSet = new Set();
            data.forEach((a) => {
                a.strategies
                    .map((b) => b.type)
                    .forEach((c) => {
                    strategiesSet.add(c);
                });
            });
            const temp = {};
            strategiesSet.forEach((a) => {
                temp[a] = [];
            });
            data.forEach((a) => {
                strategiesSet.forEach((b) => {
                    const balancedItem = a.strategies.find((c) => c.type === b);
                    if (balancedItem !== undefined) {
                        temp[b].push(balancedItem);
                    }
                });
            });
            const result = [];
            Object.keys(temp).forEach((a, index, array) => {
                if (temp[a].length > 0) {
                    result.push({
                        name: temp[a][0].name,
                        type: a,
                        volume_scale: calcMiddleValue(temp[a].sort((a, b) => Number(a.volume_scale) - Number(b.volume_scale)), "volume_scale"),
                        safety_orders: calcMiddleValue(temp[a].sort((a, b) => Number(a.safety_orders) - Number(b.safety_orders)), "safety_orders"),
                        price_scale_type: "percentage",
                        price_scale_param: calcMiddleValue(temp[a].sort((a, b) => Number(a.price_scale_param) - Number(b.price_scale_param)), "price_scale_param"),
                        price_scale: calcMiddleValue(temp[a].sort((a, b) => Number(a.price_scale_param) - Number(b.price_scale_param)), "price_scale_param"),
                        take_profit_ratio: calcMiddleValue(temp[a].sort((a, b) => Number(a.take_profit_ratio) - Number(b.take_profit_ratio)), "take_profit_ratio"),
                    });
                }
            });
            return result;
        }))
            .subscribe({
            next: (data) => {
                setItems(data);
                setError("");
                setLoading(false);
            },
            error: (error) => {
                setError(JSON.stringify(error) || `${error}`);
                setLoading(false);
            },
        });
        return () => retryOb && retryOb.unsubscribe();
    }, [pairs]);
    return [items, loading, error];
}
exports.useMTGMultiAIInfo = useMTGMultiAIInfo;
/**
 * 获取多币最小投资额
 * @param tradeApi
 * @param params
 */
function useMTGMultiMinInvest(tradeApi, params) {
    const [investStr, setInvestStr] = (0, react_1.useState)("");
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        if (params.base_list.length === 0) {
            return;
        }
        setLoading(true);
        const retryOb = (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.queryMTGMultiMinInvest(params), { maxRetryCount: 3 }).subscribe({
            next: (data) => {
                setInvestStr(data);
                setError("");
                setLoading(false);
            },
            error: (error) => {
                setError(JSON.stringify(error) || `${error}`);
                setLoading(false);
            },
        });
        return () => retryOb && retryOb.unsubscribe();
    }, [params]);
    return [investStr, new trade_utils_lib_1.SafeDecimal(investStr).mul(1.1).toString(), loading, error];
}
exports.useMTGMultiMinInvest = useMTGMultiMinInvest;
const calculateMargingaleSingleShareMin = (symbol, price) => {
    var _a, _b, _c;
    const limitBuyMin = SimpleTrading_1.SimpleTrading.getMinCost(symbol, price);
    const marketBuyMin = (_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.spending.min;
    const buyMinTemp = trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(limitBuyMin), new trade_utils_lib_1.SafeDecimal(marketBuyMin));
    let buyPrecision = (_b = symbol.precision) !== null && _b !== void 0 ? _b : symbol.precisionCost;
    if (symbol.precision !== undefined && symbol.precisionCost !== undefined) {
        buyPrecision = trade_utils_lib_1.SafeDecimal.min(symbol.precision, symbol.precisionCost).toNumber();
    }
    const buyMin = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(buyMinTemp, buyPrecision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
    const limitSellMinAmount = new trade_utils_lib_1.SafeDecimal(SimpleTrading_1.SimpleTrading.getMinAmount(symbol, price));
    const marketSellMinAmount = new trade_utils_lib_1.SafeDecimal((_c = symbol.limit) === null || _c === void 0 ? void 0 : _c.dumping.min);
    const sellMinAmount = trade_utils_lib_1.SafeDecimal.max(limitSellMinAmount, marketSellMinAmount);
    const sellMin = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(sellMinAmount.mul(new trade_utils_lib_1.SafeDecimal(price)), buyPrecision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
    return trade_utils_lib_1.SafeDecimal.max(buyMin, sellMin);
};
const calculateMartingaleMinInvest = (symbol, safety_orders, volume_scale, price) => {
    var _a, _b;
    const safetyOrdersD = new trade_utils_lib_1.SafeDecimal(safety_orders);
    const singleMin = calculateMargingaleSingleShareMin(symbol, price);
    let q = new trade_utils_lib_1.SafeDecimal(volume_scale || exports.MartingaleVolumeScaleDefault);
    const n = q.equals(1) ? safetyOrdersD.add(1) : new trade_utils_lib_1.SafeDecimal(1).sub(q.pow(safetyOrdersD)).div(new trade_utils_lib_1.SafeDecimal(1).sub(q)).add(1);
    const precision = trade_utils_lib_1.SafeDecimal.max((_a = symbol.precision) !== null && _a !== void 0 ? _a : 0, (_b = symbol.precisionCost) !== null && _b !== void 0 ? _b : 0).toNumber();
    const min = singleMin.mul(n).mul(5).toDecimalPlaces(precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
    return min.toString();
};
exports.calculateMartingaleMinInvest = calculateMartingaleMinInvest;
const calcMTGDiyMinInvest = (symbol, scaleParam, price) => {
    var _a, _b;
    let totalShares = new trade_utils_lib_1.SafeDecimal(0);
    if (Array.isArray(scaleParam)) {
        scaleParam.forEach((e) => {
            totalShares = totalShares.add(new trade_utils_lib_1.SafeDecimal(e.shares));
        });
        const singleMin = calculateMargingaleSingleShareMin(symbol, price);
        const precision = trade_utils_lib_1.SafeDecimal.max((_a = symbol.precision) !== null && _a !== void 0 ? _a : 0, (_b = symbol.precisionCost) !== null && _b !== void 0 ? _b : 0).toNumber();
        const min = singleMin.mul(totalShares).mul(1.2).toDecimalPlaces(precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
        return min.toString();
    }
    else {
        return "";
    }
};
exports.calcMTGDiyMinInvest = calcMTGDiyMinInvest;
const calcMiddleValue = (arr, params) => {
    const arrMiddleIndex = arr.length / 2;
    const arrLength = arr.length;
    let arrMiddle;
    if (arrLength % 2 === 1) {
        arrMiddle = arr[arrMiddleIndex - 0.5][`${params}`].toString();
    }
    else {
        arrMiddle = ((Number(arr[arrMiddleIndex][`${params}`]) + Number(arr[arrMiddleIndex - 1][`${params}`])) / 2).toString();
    }
    return arrMiddle;
};
